export const INVOICE_DETAILS_KEY = "client_invoiceDetails";
export class InvoiceDetailsStorageManager {
    store(invoiceRequest) {
        const invoiceDetailsData = invoiceRequest === null
            ? { isInvoiceNeeded: false, vatId: null }
            : invoiceRequest;
        const invoiceDetailsDataString = JSON.stringify(invoiceDetailsData);
        localStorage.setItem(INVOICE_DETAILS_KEY, invoiceDetailsDataString);
    }
    restore() {
        const invoiceDetailsDataString = localStorage.getItem(INVOICE_DETAILS_KEY);
        if (invoiceDetailsDataString === null) {
            return null;
        }
        return JSON.parse(invoiceDetailsDataString);
    }
    erase() {
        localStorage.removeItem(INVOICE_DETAILS_KEY);
    }
}
